// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"7de6db3190e9ebbd01a4","532":"e9f2866e92877c9588ee","691":"fd9ef10ecc5f497e2e46"}[chunkId] + ".js";
};